import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ExportDataType } from '@/types/Export'
import { Daycare } from '@/types/Daycare'
import ExportDialog from '../exportDialog.tsx'

interface ExportStaffsProps {
    daycares: Daycare[]
}

const ExportStaffs: FunctionComponent<ExportStaffsProps> = ({ daycares }: ExportStaffsProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{t('staffList')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.Staffs}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={''}
                />
            )}
        </>
    )
}

export default ExportStaffs
